import toast from 'react-hot-toast';

/**
 * Normalize ethers / MetaMask errors for UI toasts and loading-state cleanup.
 */
export function isUserRejectedError(error) {
  const code = error?.code ?? error?.info?.error?.code ?? error?.error?.code;
  if (code === 'ACTION_REJECTED' || code === 4001) return true;

  const parts = [
    error?.message,
    error?.shortMessage,
    error?.reason,
    error?.info?.error?.message,
    error?.error?.message,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return (
    parts.includes('user rejected') ||
    parts.includes('user denied') ||
    parts.includes('ethers-user-denied') ||
    parts.includes('rejectallapprovals') ||
    parts.includes('rejected the request')
  );
}

export function formatWalletError(error, fallback = 'Transaction failed. Please try again.') {
  if (!error) return fallback;
  if (typeof error === 'string') return error;

  if (isUserRejectedError(error)) {
    return 'Transaction cancelled in wallet.';
  }

  const parts = [
    error?.message,
    error?.shortMessage,
    error?.reason,
    error?.info?.error?.message,
    error?.error?.message,
  ].filter(Boolean);
  const combined = parts.join(' ').toUpperCase();

  if (combined.includes('NONCE_TOO_LOW')) {
    return (
      'Wallet nonce out of sync. Cancel stuck pending txs in MetaMask Activity, ' +
      'or Settings → Advanced → Clear activity tab data.'
    );
  }
  if (combined.includes('INSUFFICIENT_FUNDS')) {
    return 'Insufficient ETH for gas fees.';
  }

  return parts[0] || fallback;
}

/** Dismiss any active loading toasts after a wallet action ends. */
export function dismissWalletToasts() {
  toast.dismiss();
}
